import React, { useState } from "react";
import { useTranslation } from "react-i18next";

interface CopyLinkButton {
    url: string
}

const CopyLinkButton: React.FC<CopyLinkButton> = ({ url }) => {

    const [isCopied, setIsCopied] = useState<boolean>(false)
    const { t } = useTranslation('glossary')

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(url)
            setIsCopied(true)
            setTimeout(() => setIsCopied(false), 2000)
        } catch (err) {
            console.error('Failed to copy: ', err)
            const textArea = document.createElement('textarea')
            textArea.value = url
            document.body.appendChild(textArea)
            textArea.select()
            document.body.removeChild(textArea)
            setIsCopied(true)
            setTimeout(() => setIsCopied(false), 2000)
        }
    };

    return (
        <button
            onClick={copyToClipboard}
        >
            {t('copy-link')}
        </button>
    );
};

export default CopyLinkButton;